
/**
 * Reveal on viewport
 * @module Reveal
 *
 * @param {object} options
 * @property {number} offset between 0 and 1
 * @property {boolean} once
 *
 * @return {function} onenter
 * @return {function} onleave
 */

/* eslint-disable */
const Reveal = options => {
    const offset = options.offset || 0;
    const onenter = options.onenter || function(){};
    const onleave = options.onleave || function(){};
    const once = options.once || false;

    const config = {
        threshold: [offset]
    };
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > offset) {
                onenter(entry.target);
                if(once) observer.unobserve(entry.target);
            } else{
                onleave(entry.target);
            }
        });
    }, config);

    options.items.forEach(item => observer.observe(item));
};

export default Reveal;
